const Roles = Object.freeze({
    ADMIN: "admin",
    SUPERUSER: "superuser",
    USER: "user"
});
export default Roles;

  